import React from 'react';
import { Skeleton, Separator } from '@skin-seoul/design-system';

export const OrderCardSkeleton = () => {
  return (
    <div className="flex flex-col w-full bg-generic-0 border border-neutral-100 rounded-[8px] overflow-hidden gap-0">
      <div className="flex flex-col gap-3 p-3 w-full items-start">
        <div className="flex justify-between items-end w-full">
          <div className="flex flex-col gap-1 items-start">
            <div className="flex flex-row items-center gap-2">
              <Skeleton className="w-[8px] h-[8px] rounded-full" />
              <Skeleton className="w-[100px] h-[20px]" />
            </div>
            <Skeleton className="w-[150px] h-[14px]" />
          </div>
          <Skeleton className="w-[60px] h-[14px]" />
        </div>

        <div className="flex bg-primary-50 border border-primary-100 rounded-[8px] p-3 justify-between w-full">
          <div className="flex flex-col gap-1 items-start flex-1">
            <Skeleton className="w-[100px] h-[14px]" />
            <div className="flex flex-row gap-1">
              <Skeleton className="w-[80px] h-[16px]" />
              <Skeleton className="w-[16px] h-[16px]" />
            </div>
          </div>
          <div className="flex flex-col gap-1 items-end">
            <Skeleton className="w-[40px] h-[14px]" />
            <Skeleton className="w-[60px] h-[16px]" />
          </div>
        </div>

        <div className="flex flex-row gap-3 w-full">
          <div className="w-[72px] h-[72px] border border-neutral-50 rounded-[8px] overflow-hidden shrink-0">
            <Skeleton className="w-full h-full" />
          </div>

          <div className="flex flex-col gap-3 flex-1 items-start">
            <div className="flex flex-col gap-1 w-full items-start">
              <Skeleton className="w-[70%] h-[14px]" />
              <div className="flex flex-row justify-between w-full">
                <div className="flex flex-row gap-1">
                  <Skeleton className="w-[60px] h-[12px]" />
                  <Skeleton className="w-[40px] h-[12px]" />
                </div>
                <Skeleton className="w-[50px] h-[12px]" />
              </div>
            </div>
            <Skeleton className="w-[120px] h-[28px] rounded-[4px]" />
          </div>
        </div>

        <div className="flex flex-col gap-2 w-full">
          <Separator className="w-full" />
          <div className="flex flex-row justify-between w-full">
            <div className="flex flex-col gap-1 items-start">
              <Skeleton className="w-[100px] h-[12px]" />
              <Skeleton className="w-[140px] h-[16px]" />
            </div>
            <div className="flex flex-col gap-1 items-start">
              <Skeleton className="w-[100px] h-[12px]" />
              <div className="flex flex-row gap-1">
                <Skeleton className="w-[120px] h-[16px]" />
                <Skeleton className="w-[16px] h-[16px]" />
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-between w-full">
            <Skeleton className="w-[100px] h-[16px]" />
            <Skeleton className="w-[20px] h-[20px] rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};
